import types from '../mutation-types';
import ConversationApi from '../../api/inbox/conversation';
import { debounce } from '@chatwoot/utils';

const state = {
  mineCount: 0,
  unAssignedCount: 0,
  allCount: 0,
  mineUnreadCount: 0,
  unAssignedUnreadCount: 0,
  allUnreadCount: 0,
};

export const getters = {
  getStats: $state => $state,
  getTotalUnreadCount: $state => {
    // Сумма непрочитанных: мои + неназначенные
    return ($state.mineUnreadCount || 0) + ($state.unAssignedUnreadCount || 0);
  },
};

// Create a debounced version of the actual API call function
const fetchMetaData = async (commit, params) => {
  try {
    const response = await ConversationApi.meta(params);
    const {
      data: { meta },
    } = response;
    commit(types.SET_CONV_TAB_META, meta);
  } catch (error) {
    // ignore
  }
};

const debouncedFetchMetaData = debounce(fetchMetaData, 500, false, 1500);
const longDebouncedFetchMetaData = debounce(fetchMetaData, 5000, false, 10000);
const superLongDebouncedFetchMetaData = debounce(
  fetchMetaData,
  10000,
  false,
  20000
);

export const actions = {
  get: async ({ commit, state: $state }, params) => {
    if ($state.allCount > 5000) {
      superLongDebouncedFetchMetaData(commit, params);
    } else if ($state.allCount > 100) {
      longDebouncedFetchMetaData(commit, params);
    } else {
      debouncedFetchMetaData(commit, params);
    }
  },
  // Немедленное обновление (без debounce) — нужно для real-time обновлений через WebSocket
  refreshNow: async ({ commit }, params) => {
    await fetchMetaData(commit, params);
  },
  set({ commit }, meta) {
    commit(types.SET_CONV_TAB_META, meta);
  },
};

export const mutations = {
  [types.SET_CONV_TAB_META](
    $state,
    {
      mine_count: mineCount,
      unassigned_count: unAssignedCount,
      all_count: allCount,
      mine_unread_count: mineUnreadCount,
      unassigned_unread_count: unAssignedUnreadCount,
      all_unread_count: allUnreadCount,
    } = {}
  ) {
    // Важно: иногда meta приходит без наших новых ключей или "частично".
    // Не затираем текущие значения, если поле не пришло (undefined/null).
    if (mineCount !== undefined) $state.mineCount = mineCount;
    if (allCount !== undefined) $state.allCount = allCount;
    if (unAssignedCount !== undefined) $state.unAssignedCount = unAssignedCount;
    if (mineUnreadCount !== undefined) $state.mineUnreadCount = mineUnreadCount;
    if (unAssignedUnreadCount !== undefined)
      $state.unAssignedUnreadCount = unAssignedUnreadCount;
    if (allUnreadCount !== undefined) $state.allUnreadCount = allUnreadCount;
    $state.updatedOn = new Date();
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
